var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.215,
    height: 100.213,
    viewBox: "0 0 100.215 100.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2597",
    "data-name": "Groupe 2597",
    transform: "translate(-399.123 -329.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2887",
    "data-name": "Trac\\xE9 2887",
    d: "M165.324,115.18a50.106,50.106,0,1,0,50.107,50.105,50.106,50.106,0,0,0-50.107-50.105m-2.744,49.7a69.251,69.251,0,0,1-6.176,21.949,34.879,34.879,0,0,1-2.169,3.933c-.178.275-.319.533-.732.533-4.1-.012-8.208-.008-12.412-.008.573-2.083,1.147-4.079,1.672-6.084a76.188,76.188,0,0,0,1.934-8.87c.018-.128.046-.257.058-.385.186-1.694.178-1.7-1.463-1.906a17.418,17.418,0,0,1-15.134-16.3,17.433,17.433,0,0,1,23.408-17.4c6.378,2.335,10.177,7.08,11.253,13.819a39.774,39.774,0,0,1-.241,10.72m33.33,21.949a34.9,34.9,0,0,1-2.171,3.933c-.176.275-.317.533-.73.533-4.105-.012-8.21-.008-12.412-.008.573-2.083,1.145-4.079,1.67-6.084a76.189,76.189,0,0,0,1.936-8.87c.016-.128.044-.257.058-.385.184-1.694.178-1.7-1.465-1.906a17.418,17.418,0,0,1-15.134-16.3,17.435,17.435,0,0,1,23.408-17.4c6.38,2.335,10.179,7.08,11.253,13.819a39.692,39.692,0,0,1-.239,10.72,69.3,69.3,0,0,1-6.176,21.949M143.47,145.361a11.533,11.533,0,0,0,1.972,22.873,4.834,4.834,0,0,1,5.089,4.42,15.048,15.048,0,0,1,.056,4.286,61.1,61.1,0,0,1-1.549,7.653c-.154.619-.044.77.6.818.752.056,1.018-.329,1.291-.9a65.813,65.813,0,0,0,6.186-25.455c0-.718-.014-1.435,0-2.153a11.494,11.494,0,0,0-13.642-11.54",
    transform: "translate(283.906 214.041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2888",
    "data-name": "Trac\\xE9 2888",
    d: "M232.1,278.822a65.813,65.813,0,0,1-6.186,25.455c-.273.573-.539.958-1.291.9-.639-.048-.75-.2-.6-.818a61.1,61.1,0,0,0,1.549-7.653,15.047,15.047,0,0,0-.056-4.286A4.834,4.834,0,0,0,220.43,288a11.534,11.534,0,1,1,11.67-11.333c-.016.718,0,1.435,0,2.153",
    transform: "translate(208.918 94.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2889",
    "data-name": "Trac\\xE9 2889",
    d: "M429.18,278.822A65.776,65.776,0,0,1,423,304.276c-.273.573-.541.958-1.291.9-.641-.048-.752-.2-.6-.818a61.118,61.118,0,0,0,1.548-7.653,14.979,14.979,0,0,0-.054-4.286,4.836,4.836,0,0,0-5.089-4.42,11.534,11.534,0,1,1,11.67-11.333c-.016.718,0,1.435,0,2.153",
    transform: "translate(51.34 94.272)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.844563043330adaced63ba8c998e609c.svg";
export { ForwardRef as ReactComponent };